import api from '../utils/api';

const examBoardService = {
  listRegistrations: async (params) => {
    try {
      return await api.get('/api/exam-board/registrations', { params });
    } catch (error) {
      console.error('Error fetching exam board registrations:', error);
      throw error;
    }
  },
  createRegistration: async (data) => {
    try {
      return await api.post('/api/exam-board/registrations', data);
    } catch (error) {
      console.error('Error creating registration:', error);
      throw error;
    }
  },
  bulkCreateRegistrations: async (data) => {
    try {
      return await api.post('/api/exam-board/registrations/bulk', data);
    } catch (error) {
      console.error('Error bulk-registering students:', error);
      throw error;
    }
  },
  updateRegistration: async (registrationId, data) => {
    try {
      return await api.put(`/api/exam-board/registrations/${registrationId}`, data);
    } catch (error) {
      console.error('Error updating registration:', error);
      throw error;
    }
  },
  deleteRegistration: async (registrationId) => {
    try {
      return await api.delete(`/api/exam-board/registrations/${registrationId}`);
    } catch (error) {
      console.error('Error deleting registration:', error);
      throw error;
    }
  },
  // Returns the raw fetch Response (via { raw: true }) — caller does
  // response.blob() and triggers the download. See ReportCardPreviewModal.js
  // for the consumer pattern this mirrors.
  downloadHallTicket: async (registrationId) => {
    try {
      return await api.get(`/api/exam-board/registrations/${registrationId}/hall-ticket`, { raw: true });
    } catch (error) {
      console.error('Error downloading hall ticket:', error);
      throw error;
    }
  },

  payRegistrationFee: async (registrationId, data = {}) => {
    try {
      return await api.post(`/api/exam-board/registrations/${registrationId}/pay-fee`, data);
    } catch (error) {
      console.error('Error paying registration fee:', error);
      throw error;
    }
  },

  bulkImportIndexNumbers: async (data) => {
    try {
      return await api.post('/api/exam-board/registrations/bulk-index-numbers', data);
    } catch (error) {
      console.error('Error importing index numbers:', error);
      throw error;
    }
  },

  getRegistrationSubjects: async (registrationId) => {
    try {
      return await api.get(`/api/exam-board/registrations/${registrationId}/subjects`);
    } catch (error) {
      console.error('Error fetching registration subjects:', error);
      throw error;
    }
  },

  getResults: async (registrationId) => {
    try {
      return await api.get(`/api/exam-board/registrations/${registrationId}/results`);
    } catch (error) {
      console.error('Error fetching results:', error);
      throw error;
    }
  },

  submitResults: async (registrationId, results) => {
    try {
      return await api.post(`/api/exam-board/registrations/${registrationId}/results`, { results });
    } catch (error) {
      console.error('Error submitting results:', error);
      throw error;
    }
  },

  bulkImportResults: async (data) => {
    try {
      return await api.post('/api/exam-board/results/bulk-import', data);
    } catch (error) {
      console.error('Error importing results:', error);
      throw error;
    }
  },

  getAnalytics: async (params) => {
    try {
      return await api.get('/api/exam-board/registrations/analytics', { params });
    } catch (error) {
      console.error('Error fetching exam board analytics:', error);
      throw error;
    }
  },

  listSeating: async (params) => {
    try {
      return await api.get('/api/exam-board/seating', { params });
    } catch (error) {
      console.error('Error fetching seating assignments:', error);
      throw error;
    }
  },
  assignSeating: async (data) => {
    try {
      return await api.post('/api/exam-board/seating', data);
    } catch (error) {
      console.error('Error assigning seating:', error);
      throw error;
    }
  },
  deleteSeating: async (assignmentId) => {
    try {
      return await api.delete(`/api/exam-board/seating/${assignmentId}`);
    } catch (error) {
      console.error('Error deleting seating assignment:', error);
      throw error;
    }
  },

  listInvigilationDuties: async (params) => {
    try {
      return await api.get('/api/exam-board/invigilation', { params });
    } catch (error) {
      console.error('Error fetching invigilation duties:', error);
      throw error;
    }
  },
  createInvigilationDuty: async (data) => {
    try {
      return await api.post('/api/exam-board/invigilation', data);
    } catch (error) {
      console.error('Error creating invigilation duty:', error);
      throw error;
    }
  },
  deleteInvigilationDuty: async (dutyId) => {
    try {
      return await api.delete(`/api/exam-board/invigilation/${dutyId}`);
    } catch (error) {
      console.error('Error deleting invigilation duty:', error);
      throw error;
    }
  },
};

export default examBoardService;
